/**
 * @generated SignedSource<<4d53bf67d9bb3a6a2e008faf0ffc8519>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespTabsCustomizationPanel_item$data = {
  readonly attributes: {
    readonly customizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
      readonly text: string | null;
    } | null> | null;
    readonly ringResizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly isDyoCustomizable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item">;
  readonly " $fragmentType": "PdpRespTabsCustomizationPanel_item";
};
export type PdpRespTabsCustomizationPanel_item$key = {
  readonly " $data"?: PdpRespTabsCustomizationPanel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTabsCustomizationPanel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTabsCustomizationPanel_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "e720590cb5fbffe7d563569d272adedc";

export default node;
